import { useEffect } from 'react'
import { toast as showToast } from 'sonner'
import { type Toast } from '#app/utils/toast.server.ts'

export function useToast(toast?: Toast | null) {
	useEffect(() => {
		if (toast) {
			setTimeout(() => {
				showToast[toast.type](toast.title, {
					id: toast.id,
					description: toast.description,
					// ADR-025 (9.6): errors stay until closed; the rest use the
					// 8s viewport default set in root.tsx
					duration: toast.type === 'error' ? Infinity : undefined,
				})
			}, 0)
		}
	}, [toast])
}
